import { z } from 'zod';

/** Zod helper type to convert ISO date strings to Date objects */
export const IsoDateCodec = z.date()
    .or(z.codec(
        z.iso.datetime({ offset: true }),
        z.date(),
        {
            decode: (value) => new Date(value),
            encode: (value) => value.toISOString()
        }));